/**
 * Raised by a data source that cannot load until the author has chosen its scope
 * (for instance the tenants of a report). A widget can tell it apart from a real
 * failure and show its labels without a value, instead of an error.
 */
export class ScopeRequiredError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ScopeRequiredError";
  }
}

export function isScopeRequired(error: unknown): boolean {
  return error instanceof Error && error.name === "ScopeRequiredError";
}
